import React from 'react';
import {Redirect, Link} from 'react-router-dom'
import Grid from '@material-ui/core/Grid';
import Select from 'react-select';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import {withStyles} from '@material-ui/core/styles';
import ApiFetcher from '../../ApiFetcher';
import Utility from '../../Utility';
import PlantManagementUtility from "./PlantManagementUtility";

const styles = theme => ({
    select: {
        textAlign: 'left',
        margin: 'auto',
        color: theme.palette.text.primary,
        '& input': {
            font: 'inherit',
        },
        width: 'auto',
    },
    button: {
        margin: 'auto',
        width: '30%',
        marginTop: theme.spacing.unit * 8,
    },
    buttonDiv: {
        margin: 'auto',
        width: '100%',
    },
    circularProgress: {
        textAlign: 'center',
        marginTop: theme.spacing.unit * 5,
    },
    form: {
        textAlign: 'center',
        width: '90%',
        marginLeft: 'auto',
        marginRight: 'auto',
        marginTop: theme.spacing.unit * 2,
        marginBottom: theme.spacing.unit * 2,
    },
});

const DIALOG_TITLE_WORD = '熱交情報削除';

export class DeleteConstructionPlan extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            sceneList: [],
            workPlace: null,
            isWaitGetSceneList: false,
            isWaitDelete: false,
            alertDialogOpen: false,
            confirmDialogOpen: false,
            completeDialogOpen: false,
            message: [],
        };

        this.handleResponseGetSceneList = this.handleResponseGetSceneList.bind(this);
        this.getItemList = this.getItemList.bind(this);
        this.onChangeWorkPlace = this.onChangeWorkPlace.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleDeleteCsv = this.handleDeleteCsv.bind(this);
        this.handleResponseDeleteScene = this.handleResponseDeleteScene.bind(this);
        this.onConfirmDialogClose = this.onConfirmDialogClose.bind(this);
        this.onDialogCloseAndReload = this.onDialogCloseAndReload.bind(this);

        if(this.props.onScreen !== undefined){
            this.props.onScreen('工事計画CSV削除画面', true);
        }
    }

    componentDidMount(){
        this.setState({isWaitGetSceneList: true}, () => {
            ApiFetcher.getSceneList(this.props.cookies.get('token'), this.handleResponseGetSceneList);
        });
    }

    handleResponseGetSceneList(responseJson){
        if(Utility.isNullOrUndefined(responseJson.result) || Utility.isNullOrUndefined(responseJson.result.sceneNameList)){
            // 想定されるエラーは以下の通り.
            // + DBに工事計画CSVが存在しない
            // + トークン期限切れ
            // 画面が成立しないのでトップ画面に戻す.
            alert('工事計画CSVの取得に失敗したためトップ画面に戻ります。');
            this.props.history.push(this.props.backPath);
        }
        else{
            // 現場名一覧のソート.
            let sortSceneList = PlantManagementUtility.sortSceneList(responseJson.result.sceneNameList);
            this.setState({sceneList: sortSceneList, isWaitGetSceneList: false});
        }
    }

    getItemList(){
        return this.state.sceneList.map(scene => ({
            value: scene.csvId,
            label: scene.sceneName + "(" + scene.uploadDatetime + ")",
        }));
    }

    onChangeWorkPlace = (e) => {
        this.setState({workPlace: e});
    }

    handleSubmit = () => {
        // 確認ダイアログ表示.
        let confirmMsg = [
            '「' + this.state.workPlace.label + '」の熱交情報を削除します。\nよろしいですか？'
        ];
        this.setState({message: confirmMsg, confirmDialogOpen: true});
    }

    handleDeleteCsv = () => {
        this.setState({confirmDialogOpen: false, isWaitDelete: true}, () => {
            ApiFetcher.deleteScene(this.props.cookies.get('token'), this.state.workPlace.value, this.handleResponseDeleteScene);
        });
    }

    handleResponseDeleteScene = (responseJson) => {
        if (responseJson.message !== null) {
            let errorMsg = [
                '選択した現場の工事計画がサーバにありません。'
            ];
            // エラーダイアログ表示.
            this.setState({message: errorMsg, isWaitDelete: false, alertDialogOpen: true});
        }else{
            // 完了ダイアログ表示.
            this.setState({isWaitDelete: false, completeDialogOpen: true});
        }
    }

    onConfirmDialogClose(){
        // ダイアログを閉じたらメッセージ、選択現場名、各ダイアログ表示フラグをリセット.
        this.setState({message: [], workPlace: null, confirmDialogOpen: false});
    }

    onDialogCloseAndReload(){
        // ダイアログを閉じたら画面を更新.
        window.location.reload();
    }

    render(){
        // KECアカウントでない場合はアクセス不可のためトップ画面へリダイレクト.
        if(!Utility.isKecRole(this.props.cookies.get('role'))){
            return <Redirect to={{pathname: '/'}}/>;
        }

        if(this.state.isWaitGetSceneList){
            // 応答待ち表示.
            return (
                <div className={this.props.classes.circularProgress}>
                    <CircularProgress/>
                </div>
            );
        }else if(this.state.sceneList.length === 0){
            return (                
                <div className={this.props.classes.form}>
                    <div>工事計画CSVが1件もありません。</div>
                    <div className={this.props.classes.button}>
                        <Button component={(props) => <Link to={this.props.backPath} {...props}/>} variant="contained" color="primary" fullWidth>トップ画面へ戻る</Button>
                    </div>
                </div>
            );
        }else{
            return (
                <div className={this.props.classes.form}>
                    <div className={this.props.classes.select}>
                        <Grid container spacing={8}>
                            <Grid item xs={10}>
                                <Select
                                    placeholder="現場名を選択または入力して下さい"
                                    options={this.getItemList()}
                                    value={this.state.workPlace}
                                    onChange={this.onChangeWorkPlace}
                                />
                            </Grid>
                            <Grid item xs={2}>
                                <Button disabled={Utility.isNullOrUndefined(this.state.workPlace)} variant="contained" color="primary" className={this.props.classes.buttonDiv} onClick={this.handleSubmit}>
                                    削除
                                </Button>
                            </Grid>
                        </Grid>
                    </div>
                    <div className={this.props.classes.button}>
                        <Button component={(props) => <Link to={this.props.backPath} {...props}/>} variant="contained" color="primary" fullWidth>トップ画面へ戻る</Button>
                    </div>
                    <Dialog id="wait-dialog" open={this.state.isWaitDelete}>
                        <DialogContent>
                            <CircularProgress className={this.props.classes.circularProgress}/>
                        </DialogContent>
                    </Dialog>
                    <Dialog id="alert-dialog" open={this.state.alertDialogOpen} onClose={this.onDialogCloseAndReload}>
                        <DialogContent>
                            <DialogContentText style={{whiteSpace: 'pre'}}>
                                {this.state.message}
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={this.onDialogCloseAndReload} color="primary" autoFocus>
                                OK
                            </Button>
                        </DialogActions>
                    </Dialog>
                    <Dialog id="confirm-dialog" open={this.state.confirmDialogOpen} onClose={this.onConfirmDialogClose}>
                        <DialogTitle>{DIALOG_TITLE_WORD}</DialogTitle>
                        <DialogContent>
                            <DialogContentText style={{whiteSpace: 'pre'}}>
                                {this.state.message}
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={this.onConfirmDialogClose} color="primary" autoFocus>
                                いいえ
                            </Button>
                            <Button onClick={this.handleDeleteCsv} color="primary" autoFocus>
                                はい
                            </Button>
                        </DialogActions>
                    </Dialog>
                    <Dialog id="complete-dialog" open={this.state.completeDialogOpen} onClose={this.onDialogCloseAndReload}>
                        <DialogTitle>{DIALOG_TITLE_WORD}</DialogTitle>
                        <DialogContent>
                            <DialogContentText style={{whiteSpace: 'pre'}}>
                                熱交情報を削除しました。
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={this.onDialogCloseAndReload} color="primary" autoFocus>
                                OK
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            );
        }
    }
}

export default withStyles(styles)(DeleteConstructionPlan);
